/* global app */
app.controller('dialog_registerForJobCtrl', ['$rootScope', '$scope', '$http', 'NetworkService','AtlasNotification', function ($rootScope, $scope, $http, NetworkService, AtlasNotification) {
    
        $scope.fields = {};
        $scope.hasFood = event.hasfood == 1;
        $scope.foods = ["a", "b", "c"];
        $scope.selectedFood = "";
        
        $scope.requiredFieldsChecked = function(allFieldsPresent){
           $scope.gui.okButtonDisabled = !allFieldsPresent
        }

        $scope.registerForJob = function(){
            
            var data = {
                positionId: $scope.dialogInitVars.positionId,
                shiftId: $scope.dialogInitVars.shiftId,
                fields: $scope.fields,
                food: $scope.selectedFood
                };

            if(($scope.hasFood && $scope.selectedFood!="") || !$scope.hasFood){
                NetworkService.callOperation("registerMeForJob", data, function(res){
                    if(res.isSuccessfull()){
                        if($scope.dialogInitVars.acceptionPending){
                            AtlasNotification.info("Anmeldung war erfolgreich. Du bekommst jetzt noch eine E-Mail mit den letzten Details.")
                        }else{
                            AtlasNotification.info("Anmeldung erfolgreich. Wenn deine Teilnahme bestätigt wird, bekommst du eine E-Mail.")
                        }
                        
                    
                    $rootScope.$emit("updateCalendar");
                    }})
            }else{
                AtlasNotification.info("Bitte wähle eine Verpflegung aus.");
            }
            
            var dialog = new mdc.dialog.MDCDialog(document.querySelector("#registerForJob_"+$scope.dialogInitVars.positionId+"_Dialog"));
            if($scope.hasFood){
                if($scope.selectedFood!=""){
                    dialog.buttons_[0].click()
                }
            }else{
                dialog.buttons_[0].click()
            }
        }
    }])